import styled from '@emotion/styled'

import { LineHeight } from '../../../../../../enums/lineHeight'
import { Text } from '../../../../../Text'

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const TableCellContent = styled(Text)`
  width: 100%;
`

export const TableSkeletonCellContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${LineHeight.TextBodyMD};
`
